import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, MainHeading, SpanStyled } from '../../ui/Elements'
import { ArrowBtnBrown, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import Transform from './transform/Transform'
const About = () => {
    const { t } = useTranslation()
    
    return (
        <Box  id='about'>
            <AboutWapper className='container-fluid secAbout common-space'>
                <Container>
                    <Row className='about-row'>
                        <Col lg={6} md={12} className='about-col'>
                            <Box className='gridStats'>
                                <AboutBox 
                                    stats="8+"
                                    statsTitle={t('YearsExperience')}
                                    bgimage={StatsBg1}
                                />
                                <AboutBox 
                                    stats="50+"
                                    statsTitle={t('HomeDesigned')}
                                    bgimage={StatsBg2}
                                />
                                <AboutBox 
                                    stats="150+"
                                    statsTitle={t('ProjectsCompleted')}
                                    bgimage={StatsBg3}
                                />
                                <AboutBox 
                                    stats="120+"
                                    statsTitle={t('HappyCustomers')}
                                    bgimage={StatsBg4}
                                />
                            </Box>
                            
                            
                        </Col>
                        <Col lg={6} md={12} className='about-arabic'>
                            <Box className='bannerContent'>
                                <MainHeading className='main-heading main-heading-sub' size="32px" color="var(--secondaryColor)">
                                    {t('OurStory')}
                                </MainHeading>
                                <MainHeading className='main-heading mb-3'>
                                    {t('AJourneyInspiredLiving')}
                                </MainHeading>
                                <SpanStyled className='aboutDesc mb-4'>
                                    {t('aboutDesc')}
                                </SpanStyled>

                                <MainHeading className='main-heading mb-3 abtHeadSec' size="24px" color="">
                                    {t('AJourneyInspiredLiving')}
                                </MainHeading>
                                <Box className="ctPointsList">
                                    <ul>
                                        <li>
                                            <Box className='checkList'>
                                                <ArrowBtnBrown />
                                            </Box>
                                            <Box className='listContent'>
                                                <SpanStyled lh="1.5">
                                                    {t('abtList1')}
                                                </SpanStyled>
                                            </Box>
                                        </li>
                                        <li>
                                            <Box className='checkList'>
                                                <ArrowBtnBrown />
                                            </Box>
                                            <Box className='listContent'>
                                                <SpanStyled lh="1.5">
                                                    {t('abtList2')}
                                                </SpanStyled>
                                            </Box>
                                        </li>
                                        <li>
                                            <Box className='checkList'>
                                                <ArrowBtnBrown />
                                            </Box>
                                            <Box className='listContent'>
                                                <SpanStyled lh="1.5">
                                                    {t('abtList3')}
                                                </SpanStyled>
                                            </Box>
                                        </li>
                                    </ul>
                                </Box>
                                
                            </Box>
                        </Col>
                        
                    </Row>
                </Container>
                <Box className='stripe stripe1'></Box>
            </AboutWapper>
            <Transform />
        </Box>
    )
}
const AboutWapper = styled.section`
    .about-row {
        align-items: center;
    }
    .gridStats{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 34px;
    }
    .ctPointsList{
        display: block;
        width: 100%;
        padding: 0;
        ul{
            display: block;
            width: 100%;
            padding: 0;
            li{
                display: flex;
                width: 100%;
                padding: 0;
                gap: 14px;
                align-items: flex-start;
                margin-bottom: 12px;
                span{
                    width: 100%;
                }
                .listContent{
                    display: flex;
                    width: 100%;
                    flex-wrap: wrap;
                    padding-top: 1px;
                }
                .checkList{
                    min-width: 20px;
                    max-width: 20px;
                }
            }
        }
    }
    .stripe{
        display: flex;
        width: 100%;
        height: 57px;
        background-size: auto;
        background-position: center;
        margin-top: 80px;
    }
    .stripe1{
        background-image: url(${StripeBg});
    }
    body.rtl &{
        .stripe1{
            background-image: url(${StripeBgAr});
        }
        .abtHeadSec{
            font-size: 24px;
        }
    }
    @media (max-width: 1199px) {
        .stripe1{
            background-size: 160% auto;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
    @media (max-width: 991px) {
        .about-col{
            margin-bottom: 40px;
        }
        .gridStats{
            gap: 20px;
        }
        .stripe{
            margin-top: 60px;
            margin-bottom: 50px;
        }
        
    }
    @media (max-width: 767px) {
        .stripe{
            height: 30px;
        }
        .stripe1{
            background-size: 250% auto;
        }
    }
    @media (max-width: 575px) {
        .gridStats{
            grid-template-columns: 1fr;
        }
    }
`
export default About
